import {CustomMenu} from '../../../menus/custom-menu';
import {useSettings} from '../../../core/settings/use-settings';

export function AuthLayoutFooter() {
  const {branding} = useSettings();
  return (
    <div className="pt-42 pb-32 flex items-center gap-30 text-sm text-muted mt-auto">
      <span>
        Copyright © 2026{' '}
        <a
          href="https://messenger2050.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-fg-base transition-colors"
        >
          Messenger2050
        </a>
        , All Rights Reserved
      </span>
      <CustomMenu
        menu="auth-page-footer"
        orientation="horizontal"
        itemClassName="hover:text-fg-base transition-colors"
      />
    </div>
  );
}
